// Theme resolver — the entry point for all theme consumers.
//
// The active brand is selected by the REACT_APP_BRAND env var at build/run
// time, e.g. `cross-env REACT_APP_BRAND=karuna craco start`. Defaults to
// `revivo`. Unknown values fall back to the default with a console warning.

import { brands, DEFAULT_BRAND } from "./brands";

const requested = (process.env.REACT_APP_BRAND || DEFAULT_BRAND)
  .trim()
  .toLowerCase();

if (!brands[requested]) {
  // eslint-disable-next-line no-console
  console.warn(
    `[theme] Unknown REACT_APP_BRAND "${requested}". Falling back to "${DEFAULT_BRAND}". ` +
      `Known brands: ${Object.keys(brands).join(", ")}.`
  );
}

export const activeBrand = brands[requested] || brands[DEFAULT_BRAND];

// Flat color palette — the canonical map. Keys are camelCase.
export const palette = activeBrand.colors;

export const overlays = activeBrand.overlays;
export const gradients = activeBrand.gradients;
export const fonts = activeBrand.fonts;
export const productName = activeBrand.productName;
export const productEdition = activeBrand.productEdition;

// Grouped semantic view over the flat palette, for UI-library theme builders
// (AntD / MUI) that prefer nested tokens.
export const semanticTokens = {
  brand: {
    primary: palette.primary,
    primaryHover: palette.primaryHover,
    primaryDark: palette.primaryDark,
    primaryLight: palette.primaryLight,
    accent: palette.accent,
  },
  surface: {
    page: palette.surfacePage,
    card: palette.surface,
    muted: palette.surfaceMuted,
    border: palette.border,
    borderMuted: palette.borderMuted,
  },
  text: {
    primary: palette.textPrimary,
    secondary: palette.textSecondary,
    muted: palette.textMuted,
    placeholder: palette.textPlaceholder,
    inverse: palette.textInverse,
  },
  status: {
    success: palette.success,
    warning: palette.warning,
    error: palette.danger,
  },
};

export default activeBrand;
